import { StorageKeyEnum } from '@/constants/storage'
import { logger } from '@/features/auth/logger'
import { oauthAccessToken } from '@/features/auth/oauthAccessToken'
import { getAuth, signOut } from '@/features/firebase/adapter/auth'
import StorageService from '@/services/storage'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const logoutCurrentProfile = createAsyncThunk<void, void>(
    'auth/logoutCurrentProfile',
    async () => {
        try {
            oauthAccessToken.clear()

            await StorageService.removeByKeys([
                StorageKeyEnum.CurrentProfileUuid,
                StorageKeyEnum.RefreshToken,
            ])

            await signOut(getAuth())
        } catch (e) {
            logger.errorOnly(e)
        }
    }
)

export const logoutDevice = createAsyncThunk<void, void>('auth/logoutDevice', async () => {
    try {
        oauthAccessToken.clear()

        await StorageService.removeByKeys([
            StorageKeyEnum.CurrentProfileUuid,
            StorageKeyEnum.RefreshToken,
        ])

        await signOut(getAuth())
    } catch (e) {
        logger.errorOnly(e)
    }
})
